import { Component, Mixins } from 'vue-property-decorator';
import { IScene } from '@/helpers/editor';
import TopNav from '@/components/topnav/TopNav.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import CreateSceneModal from '@/components/editor/modals/CreateSceneModal.vue';
import { EModalName } from '@/helpers/modal';
import SceneMixins from './SceneMixins';
import StreamStatus from '@/components/editor/StreamStatus.vue';
import Tooltip from '@/components/utils/Tooltip.vue';
import UserApi from '@/apis/user-api';
import DraggableStreamContainer from '@/components/editor/DraggableStreamContainer.vue';
import TransitionLibraryMobileModal from '@/components/editor/modals/TransitionLibraryMobileModal.vue';
import { ESocketEvent } from '@/helpers/socket';
import NewsUpdateButton from '@/components/topnav/NewsUpdateButton.vue';

@Component({
  components: {
    TopNav,
    ConfirmationModal,
    CreateSceneModal,
    StreamStatus,
    Tooltip,
    DraggableStreamContainer,
    TransitionLibraryMobileModal,
    NewsUpdateButton,
  },
})
export default class ScenePageMobile extends Mixins(SceneMixins) {
  tapCount: number = 0;
  tooltipDismissed: boolean = false;

  async mounted() {
    if (!this.selectedProject)
      await this.loadSelectedProject(this.$route.params.projectUuid);

    this.openCheckoutModalMiniOnUserFlag();
    await this.maybeDisplaySaveButtonTooltip();
  }

  get hasScene(): boolean {
    return !!this.scenes.length;
  }

  get isPreview(): boolean {
    return this.streamStatus === 'Preview';
  }

  get scenes(): IScene[] {
    return this.selectedProject?.scenes || [];
  }

  get activeScene(): IScene {
    if (!this.selectedProject && !this.selectedProject.active_scene_id) return null;

    const scene = this.scenes.find((scene) => scene.id === this.selectedProject.active_scene_id);

    return scene;
  }

  openCreateSceneModal() {
    this.$modal.show(EModalName.createScene);
  }

  async editScene(scene: IScene) {
    this.selectedScene = scene;
    this.$router.push(`/projects/${this.selectedProject.uuid}/scenes/${scene.uuid}/editor`);
  }

  async sceneTapListener(scene: IScene) {
    // listen to both single and double click
    this.tapCount++;

    if (this.tapCount === 1) {
      setTimeout(() => {
        if (this.tapCount === 1) {
          this.setSceneAsActive(scene);
          this.sendSocketEvent(ESocketEvent.updateScene);
        } else {
          this.editScene(scene);
        }

        this.tapCount = 0;
      }, 300);

      return;
    }
  }

  async closeTooltip() {
    this.tooltipDismissed = true;

    await UserApi.setUserEditorOnboardingShown();
  }
}
